import React from 'react';

type Props = {
  children?: React.ReactNode;
};
const Tab = ({children}: Props) => (
  <ul className="flex border-b border-neutral-100 text-left [&_a]:mr-[25px] [&_a]:block [&_a]:py-[10px] [&_a]:text-sm [&_a]:text-neutral-500 [&_span]:ml-[5px] [&_span]:text-xs">
    {children}
  </ul>
);

export default Tab;
